import * as React from 'react';

import * as videoPresentation from '../styles/videoPresentation.module.scss';

export const VideoPresentation = () => {
  return (
    <section className={videoPresentation.videoPresentation}>
      <div className={'container'}>
        <div className={`row ${videoPresentation.videoPresentation__wrapper}`}>
          <p className={`col-lg-6 ${videoPresentation.videoPresentation__text}`}>
            Мы весело и интересно разбираем правила, с фантазией подходим к&nbsp;каждому упражнению, иллюстрации покруче
            многих мультиков, а наш сценарий просто захватывает дух!
          </p>
          <div className={`col-lg-6 ${videoPresentation.videoPresentation__video}`}>
            <iframe
              src={'https://65395.servicecdn.ru/videos/65395_bIhl6pIMOs54vYAM'}
              title={'Видео-фрагмент из урока по английскому языку'}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};
